import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const SalesBooking = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, salesBooking: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}

	const steps = [
		{
			target: '.salesBookingFirstStep',
			title: "Select Status",
			content: 'Select specific status.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.salesBookingSecondStep',
			title: "Select Start Date",
			content: 'The date you want to start the report.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.salesBookingThirdStep',
			title: "Select End Date",
			content: 'Select the end date you want the report to show.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.salesBookingFourthStep',
			title: "Generate Report",
			content: 'Click to generate the report.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.salesBookingFifthStep',
			title: "Export In Excel",
			content: 'Click to download the report as excile file.',
			disableBeacon: true,
			placement: "bottom",
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.salesBookingFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.salesBooking)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="salesBooking" 
			featureName="reports"
		/>
	);
}
